export default __webpack_public_path__ + "media/images/images_v2/ongletwhite-right-c9182948f7bb664898c00df83b4651c1.png";